import { useAuthContext } from "../../../context-state/AuthContext";
import { LinearLoader } from "../../../components/linear-loader/LinearLoader";
import { useSnackbar } from "../../../components/minimal/snackbar";
import { useEffect } from "react";
import myMembersStore from "../../../stores/myMembers.store";
import { observer } from "mobx-react-lite";
import { useLocales } from '@locales';

export const MyMembersGuard = observer(({ children }) => {

    const { getPrimaryAccount } = useAuthContext()
    const { enqueueSnackbar } = useSnackbar();
    const seller = getPrimaryAccount()
    const { translate } = useLocales();

    useEffect(() => {
        if (myMembersStore.endUserSeasonTickets.length) {
            return
        }

        myMembersStore.init(seller.marketPlace._id, seller._id)
            .catch(error => {
                enqueueSnackbar(translate('my_members.error_loading'), { variant: 'error' })
                console.error(error)
            })
    }, [])

    return (
        myMembersStore?.loading ? <LinearLoader /> : children
    )
})